import { OrganizationUsersScreen } from "../organization-users";

// Organization → Employees. Members of the current organization holding the
// "employee" role — a filtered view of the shared team-management screen.
const Employees = () => <OrganizationUsersScreen roleFilter="employee" />;

export default Employees;
